module.exports = __webpack_public_path__ + "static/media/Dzenis-H.986b773c.pdf";